import { useEffect } from 'react';
import { NavLink } from 'react-router-dom'
import { withRouter, matchPath } from "react-router";
import { useTranslation } from 'react-i18next';
import styles from './Header.module.less'
import ReactConfig from '@/router/config'
import Logo from './Logo'
// import LanguageChange from '../common/LanguageChange'
import LanguageChange from '@/guanwang_common/pages/LanguageChange'

function Index(props) {
  const { i18n, t } = useTranslation()
  // const changeLanguage = (lang) => {
  //   i18n.changeLanguage(lang)
  //   history.push(`/${lang}/`)
  // }

  useEffect(() => {
    //切换语言时要做的事情
    // console.log('init', i18n.language)
  }, [i18n.language])

  const isActive = (match, location, item) => {
    if (!match) {
      return false
    }
    return matchPath(location.pathname, item.routeConf);
  }

  const navLinks = [
    { text: t('home'), to: "/", routeConf: ReactConfig.find(item => item.name === 'index')},
    { text: t('products'), to: "/products", routeConf: ReactConfig.find(item => item.name === 'products')},
    { text: t('aboutUs'), to: "/about", routeConf: ReactConfig.find(item => item.name === 'about')}
  ];

  return (
    <header className={`${styles.header}`}>
      <div className="mod">
        <Logo className={styles.logo} />
        <nav className={styles.nav}>
          {
            navLinks.map(item => (
              <NavLink
                key={item.to}
                to={item.to}
                activeClassName={styles.active}
                isActive={ (match, location) => isActive(match, location, item) }
              >{item.text}</NavLink>
            ))
          }
        </nav>
        <LanguageChange />
      </div>
    </header>
  );
}

export default withRouter(Index);
